// extracted by mini-css-extract-plugin
module.exports = {"page_container":"style_page_container__tAGfB","section":"style_section__7IzTq","desktop_game_page":"style_desktop_game_page__TISBL"};